// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ij-z","carouselContainer":"jj-z","carouselContent":"kj-z"};